import * as React from "react";
import type { SVGProps } from "react";
const SvgQuotation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.366 18.797A1 1 0 0 0 6 19h.24A5.72 5.72 0 0 0 11 13V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3v1a3.75 3.75 0 0 1-3.27 4.03 1 1 0 0 0-.364 1.767ZM6 10V7h3v3H6ZM14.366 18.797A1 1 0 0 0 15 19h.24A5.72 5.72 0 0 0 20 13V7a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3v1a3.75 3.75 0 0 1-3.27 4.03 1 1 0 0 0-.364 1.767ZM15 10V7h3v3h-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgQuotation;
